import { Button, Stack, Title, Text } from '@mantine/core';
import AccessibilityNewOutlinedIcon from '@mui/icons-material/AccessibilityNewOutlined';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import classes from '../../../app.module.css';
import { useTranslation } from 'react-i18next';

export const MeasurementListEntry = ({
  location,
  date,
  onClick,
}: {
  location: string;
  date: Date;
  onClick: () => void;
}) => {
  const { i18n } = useTranslation();
  return (
    <Button
      variant="widget"
      fullWidth
      onClick={onClick}
      leftSection={
        <AccessibilityNewOutlinedIcon
          style={{
            fontSize: 35,
            padding: 4,
            border: '1px solid',
            borderRadius: '50%',
          }}
        />
      }
      rightSection={<ChevronRightIcon />}
      style={{ paddingTop: 8, paddingBottom: 8 }}
      classNames={{
        inner: classes.flexStartButtonInner,
        label: classes.flexGrowButtonLabel,
      }}
    >
      <Stack
        gap={0}
        style={{ textAlign: 'start', marginLeft: 'var(--mantine-spacing-sm)' }}
      >
        <Title order={4}>{location}</Title>
        <Text>{date.toLocaleDateString(i18n.language)}</Text>
      </Stack>
    </Button>
  );
};
